module.exports = __webpack_public_path__ + "static/media/ic_copy_session_link.b97dc932.svg";